import React from "react"
import {useTranslation} from "react-i18next"

// Components
import Kbd from "../../../../../components/modern/Kbd"

// Styles
import useStyles from "./styles"

type ModernKeysBarProps = {
    /** Save / approve hints are pointless on the read-only preview route. */
    showEditingKeys: boolean
    showPagingKeys: boolean
}

/**
 * The 42 px footer legend. Every hint below is actually bound in
 * `useRecordShortcuts` — nothing is listed here that does not do something.
 *
 * @param props
 */
export default function ModernKeysBar(props: ModernKeysBarProps) {
    const styles = useStyles();
    const [t] = useTranslation("common");

    return (
        <footer className={styles.keysbar}>
            <div className={styles.hints}>
                <span className={styles.hint}><Kbd>H</Kbd> {t("modern.dashboard")}</span>
                {props.showEditingKeys && (
                    <span className={styles.hint}>
                        <Kbd>1</Kbd>–<Kbd>6</Kbd> {t("modern.keys.conclusion")}
                    </span>
                )}
                <span className={styles.hint}>
                    <Kbd>+</Kbd>/<Kbd>−</Kbd>/<Kbd>0</Kbd> {t("modern.keys.zoom")}
                </span>
                {props.showPagingKeys && (
                    <span className={styles.hint}>
                        <Kbd>←</Kbd>/<Kbd>→</Kbd> {t("modern.keys.page")}
                    </span>
                )}
                <span className={styles.hint}><Kbd>C</Kbd> {t("modern.calipers")}</span>
                <span className={styles.hint}><Kbd>S</Kbd> {t("modern.sidebar")}</span>
                <span className={styles.hint}><Kbd>D</Kbd> {t("modern.keys.reading_room")}</span>
                <span className={styles.hint}><Kbd>[</Kbd> {t("modern.panel")}</span>
                <span className={styles.hint}><Kbd>O</Kbd> {t("modern.keys.clinical_info")}</span>
                {props.showEditingKeys && (
                    <span className={styles.hint}>
                        <Kbd>Ctrl</Kbd>+<Kbd>S</Kbd> {t("modern.keys.save")}
                    </span>
                )}
                {props.showEditingKeys && (
                    <span className={styles.hint}>
                        <Kbd>Ctrl</Kbd>+<Kbd>Enter</Kbd> {t("modern.keys.approve_next")}
                    </span>
                )}
            </div>
        </footer>
    )
}
